var _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _path8, _path9, _path10, _path11, _path12, _mask2, _path13, _path14, _mask3, _path15, _path16, _path17, _mask4, _path18, _path19, _mask5, _path20, _path21, _path22, _mask6, _path23, _path24, _mask7, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHerdDetailesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8463 11.156L17.8495 12.1943L9.55579 16.9819L0.151465 11.5194V10.4812L8.44169 5.68973L17.8463 11.156Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4037 16.8945L0.153192 11.5187L0.150741 10.654L9.40124 16.0298L9.4037 16.8945Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8456 11.3277L17.848 12.194L9.70373 16.8961L9.70127 16.0298L17.8456 11.3277Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6955 11.068L9.55124 15.7701L0.299265 10.3934L8.44357 5.69129L17.6955 11.068Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34971 11.3871L9.36223 14.9042L1.42292 10.2932L1.40977 6.59623C1.40977 6.59619 1.40977 6.59615 1.40977 6.59612C1.40766 5.50616 1.79121 4.28607 2.42045 3.19671C3.04968 2.10734 3.91644 1.16282 4.86568 0.615515L4.86586 0.615407C5.8202 0.0633264 6.65374 0.0310257 7.23361 0.368646L7.2337 0.368698L14.5811 4.63984C14.0804 4.64753 13.5271 4.81328 12.956 5.14107L12.9555 5.14134C11.9502 5.72328 11.0493 6.71143 10.4006 7.83445C9.75196 8.95743 9.34744 10.2292 9.34971 11.3868L9.34971 11.3871Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.955 5.14213C11.3022 6.10232 9.9198 8.16345 9.48866 10.1412L1.52341 5.51341C1.91415 3.57551 3.26983 1.53924 4.86704 0.615132L4.86707 0.615112C5.82052 0.0631301 6.65422 0.0317384 7.23504 0.368762L14.5815 4.6406C14.0805 4.64791 13.5268 4.81336 12.9556 5.14178L12.955 5.14213Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59428 10.3761L1.35596 5.58936L9.59428 10.3761Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.745 10.1167L1.50667 5.32996L1.20524 5.84875L9.44357 10.6355L9.745 10.1167Z",
    fill: "#00609B",
    mask: "url(#path-7-inside-1_525_9378)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1061 5.4031C14.0558 4.85479 14.8823 4.81966 15.4624 5.15042C16.042 5.48099 16.4285 6.2073 16.4316 7.29892L16.442 10.9924L9.66195 14.9069L9.65197 11.3855C9.64888 10.2946 10.0318 9.0746 10.6607 7.98526C11.2896 6.89597 12.1564 5.95142 13.1061 5.4031Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4527 8.77818L14.4639 12.1416L11.6368 13.7713L11.6288 10.9586V10.9584V10.4079L14.4527 8.77818Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9837 10.6121L14.0998 9.39014L14.1113 12.1735L11.9837 10.9371V10.6121Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9837 11.5764V11.5762V11.2839L13.9619 12.4335L11.9898 13.5692L11.9837 11.5764Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55633 3.71784C4.73873 3.61443 4.8902 3.46296 4.99361 3.28057C5.09702 3.46298 5.24851 3.61446 5.43094 3.71787C5.24854 3.82129 5.09706 3.97278 4.99364 4.15517C4.89023 3.97275 4.73875 3.82125 4.55633 3.71784Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-2_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32595 9.5466L2.32968 7.48242L2.07846 7.33618L2.07471 9.6741L2.32595 9.5466Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32595 9.5466L2.32968 7.48242L2.07846 7.33618L2.07471 9.6741L2.32595 9.5466Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32595 9.5466L2.46171 9.81413L2.62562 9.73095L2.62595 9.54714L2.32595 9.5466ZM2.32968 7.48242L2.62968 7.48297L2.62999 7.31011L2.48061 7.22315L2.32968 7.48242ZM2.07846 7.33618L2.22939 7.07691L1.7793 6.8149L1.77846 7.3357L2.07846 7.33618ZM2.07471 9.6741L1.77471 9.67362L1.77392 10.1632L2.21047 9.94162L2.07471 9.6741ZM2.62595 9.54714L2.62968 7.48297L2.02968 7.48188L2.02595 9.54606L2.62595 9.54714ZM2.48061 7.22315L2.22939 7.07691L1.92753 7.59545L2.17875 7.74169L2.48061 7.22315ZM1.77846 7.3357L1.77471 9.67362L2.37471 9.67458L2.37846 7.33666L1.77846 7.3357ZM2.21047 9.94162L2.46171 9.81413L2.19019 9.27908L1.93895 9.40658L2.21047 9.94162Z",
    fill: "#00609B",
    mask: "url(#path-14-inside-2_525_9378)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-3_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32595 9.54663L2.07471 9.67413L4.90956 11.3088V11.0389L2.32595 9.54663Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32595 9.54663L2.07471 9.67413L4.90956 11.3088V11.0389L2.32595 9.54663Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32595 9.54663L2.47599 9.28685L2.33519 9.20552L2.19019 9.27911L2.32595 9.54663ZM2.07471 9.67413L1.93895 9.4066L1.44496 9.65729L1.92484 9.93402L2.07471 9.67413ZM4.90956 11.3088L4.75969 11.5687L5.20956 11.8281V11.3088H4.90956ZM4.90956 11.0389H5.20956V10.8657L5.0596 10.7791L4.90956 11.0389ZM2.19019 9.27911L1.93895 9.4066L2.21047 9.94165L2.46171 9.81415L2.19019 9.27911ZM1.92484 9.93402L4.75969 11.5687L5.05942 11.049L2.22457 9.41424L1.92484 9.93402ZM5.20956 11.3088V11.0389H4.60956V11.3088H5.20956ZM5.0596 10.7791L2.47599 9.28685L2.1759 9.80641L4.75951 11.2987L5.0596 10.7791Z",
    fill: "#00609B",
    mask: "url(#path-16-inside-3_525_9378)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76072 10.7797L2.47633 9.46023L2.47943 7.74227L4.76697 9.06488L4.76072 10.7797Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-4_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14577 11.7571L6.1495 9.69287L5.89828 9.54663L5.89453 11.8845L6.14577 11.7571Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14577 11.7571L6.1495 9.69287L5.89828 9.54663L5.89453 11.8845L6.14577 11.7571Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14577 11.7571L6.28153 12.0246L6.44544 11.9414L6.44577 11.7576L6.14577 11.7571ZM6.1495 9.69287L6.4495 9.69341L6.44982 9.52056L6.30043 9.4336L6.1495 9.69287ZM5.89828 9.54663L6.04921 9.28736L5.59912 9.02535L5.59828 9.54615L5.89828 9.54663ZM5.89453 11.8845L5.59453 11.8841L5.59375 12.3736L6.03029 12.1521L5.89453 11.8845ZM6.44577 11.7576L6.4495 9.69341L5.8495 9.69233L5.84577 11.7565L6.44577 11.7576ZM6.30043 9.4336L6.04921 9.28736L5.74736 9.8059L5.99858 9.95214L6.30043 9.4336ZM5.59828 9.54615L5.59453 11.8841L6.19453 11.885L6.19828 9.54711L5.59828 9.54615ZM6.03029 12.1521L6.28153 12.0246L6.01001 11.4895L5.75877 11.617L6.03029 12.1521Z",
    fill: "#00609B",
    mask: "url(#path-19-inside-4_525_9378)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-5_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14577 11.757L5.89453 11.8845L8.72938 13.5192V13.2493L6.14577 11.757Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14577 11.757L5.89453 11.8845L8.72938 13.5192V13.2493L6.14577 11.757Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14577 11.757L6.29582 11.4972L6.15501 11.4159L6.01001 11.4895L6.14577 11.757ZM5.89453 11.8845L5.75877 11.617L5.26478 11.8677L5.74467 12.1444L5.89453 11.8845ZM8.72938 13.5192L8.57952 13.7791L9.02938 14.0385V13.5192H8.72938ZM8.72938 13.2493H9.02938V13.0761L8.87943 12.9895L8.72938 13.2493ZM6.01001 11.4895L5.75877 11.617L6.03029 12.152L6.28153 12.0245L6.01001 11.4895ZM5.74467 12.1444L8.57952 13.7791L8.87925 13.2593L6.04439 11.6246L5.74467 12.1444ZM9.02938 13.5192V13.2493H8.42938V13.5192H9.02938ZM8.87943 12.9895L6.29582 11.4972L5.99573 12.0168L8.57934 13.509L8.87943 12.9895Z",
    fill: "#00609B",
    mask: "url(#path-21-inside-5_525_9378)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58055 12.99L6.29615 11.6706L6.29926 9.95266L8.5868 11.2753L8.58055 12.99Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-6_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9193 7.59667L13.9165 6.05662L14.1039 5.94751L14.1067 7.69179L13.9193 7.59667Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9193 7.59667L13.9165 6.05662L14.1039 5.94751L14.1067 7.69179L13.9193 7.59667Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9193 7.59667L13.6193 7.59721L13.6196 7.78102L13.7835 7.86419L13.9193 7.59667ZM13.9165 6.05662L13.7656 5.79735L13.6162 5.88431L13.6165 6.05716L13.9165 6.05662ZM14.1039 5.94751L14.4039 5.94703L14.4031 5.42623L13.953 5.68824L14.1039 5.94751ZM14.1067 7.69179L13.971 7.95932L14.4075 8.18085L14.4067 7.69131L14.1067 7.69179ZM14.2193 7.59613L14.2165 6.05608L13.6165 6.05716L13.6193 7.59721L14.2193 7.59613ZM14.0674 6.31589L14.2549 6.20678L13.953 5.68824L13.7656 5.79735L14.0674 6.31589ZM13.8039 5.94799L13.8067 7.69228L14.4067 7.69131L14.4039 5.94703L13.8039 5.94799ZM14.2425 7.42427L14.055 7.32915L13.7835 7.86419L13.971 7.95932L14.2425 7.42427Z",
    fill: "#00609B",
    mask: "url(#path-24-inside-6_525_9378)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-7_525_9378",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9195 7.59637L14.107 7.6915L11.9919 8.91113V8.70972L13.9195 7.59637Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9195 7.59637L14.107 7.6915L11.9919 8.91113V8.70972L13.9195 7.59637Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9195 7.59637L14.0553 7.32885L13.9103 7.25527L13.7695 7.33659L13.9195 7.59637ZM14.107 7.6915L14.2568 7.95139L14.7367 7.67466L14.2427 7.42397L14.107 7.6915ZM11.9919 8.91113H11.6919V9.43043L12.1418 9.17102L11.9919 8.91113ZM11.9919 8.70972L11.8419 8.44994L11.6919 8.53655V8.70972H11.9919ZM13.7838 7.8639L13.9712 7.95902L14.2427 7.42397L14.0553 7.32885L13.7838 7.8639ZM13.9571 7.43161L11.8421 8.65125L12.1418 9.17102L14.2568 7.95139L13.9571 7.43161ZM12.2919 8.91113V8.70972H11.6919V8.91113H12.2919ZM12.142 8.9695L14.0696 7.85616L13.7695 7.33659L11.8419 8.44994L12.142 8.9695Z",
    fill: "#00609B",
    mask: "url(#path-26-inside-7_525_9378)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1364 7.25912L13.767 6.31636L13.7691 7.5102L12.1407 8.45072L12.1364 7.25912Z",
    fill: "white",
    stroke: "#00609B",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdDetailesIcon);
export default __webpack_public_path__ + "static/media/HerdDetailesIcon.9efc0557068cd31e73bcafb2ef067925.svg";
export { ForwardRef as ReactComponent };